import React, { useEffect } from 'react';
import { classes } from './UnavailableSlotMessage.st.css';
import {
  SectionMessage,
  SectionMessageType,
} from '../SectionMessage/SectionMessage';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { UnavailableSlotMessageDataHooks } from './dataHooks';
import { useFormActions } from '../../Hooks/useFormActions';
import { bookingsUoUBookingFormClickSrc16Evid83 } from '@wix/bi-logger-bookings-data/v2';
import {
  BookingFormClickActions,
  BookingFormClickComponents,
} from '../../../../types/biLoggerTypes';

export const UnavailableSlotMessage: React.FC = () => {
  const { t } = useTranslation();
  const { navigateToCalendarPage, logBi } = useFormActions();

  useEffect(() => {
    logBi([
      bookingsUoUBookingFormClickSrc16Evid83({
        component: BookingFormClickComponents.AvailabilityError,
        action: BookingFormClickActions.Load,
      }),
    ]);
  }, [logBi]);

  const handleButtonClick = () => {
    logBi([
      bookingsUoUBookingFormClickSrc16Evid83({
        component: BookingFormClickComponents.PickNewTime,
        action: BookingFormClickActions.Click,
      }),
    ]);
    navigateToCalendarPage();
  };

  return (
    <SectionMessage
      type={SectionMessageType.Error}
      text={t('app.bookings-form.slot-unavailable.notification')}
      className={classes.root}
      dataHook={UnavailableSlotMessageDataHooks.NOTIFICATION_MESSAGE}
      buttonText={t('app.bookings-form.slot-unavailable.cta')}
      buttonOnClick={handleButtonClick}
    />
  );
};
